import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-logo-krediya',
  templateUrl: './logo-krediya.component.html',
})

export class LogoKrediyaComponent {
  @Input() color: string = '';
}
